/**
 * DUNAMIS WEAR — Product Form
 */
(function () {
  'use strict';
  const theme = window.theme;
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) {
      const sizeSection = form.querySelector('[data-size-selector]');
      if (sizeSection) sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    btn.disabled = true;
    btn.classList.add('is-loading');

    theme.addToCart({
      id: parseInt(variantInput.value, 10),
      quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1, 10)
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      setTimeout(function () { btn.classList.remove('is-success'); btn.disabled = false; }, 2000);
    }).catch(function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  });

  /* Sticky mobile ATC — bar lives in theme.liquid (body level) for correct fixed positioning */
  const stickyBar = document.getElementById('StickyATC');
  const mainBtn = document.querySelector('[data-product-form] [type="submit"]');
  let stickyObserver = null;

  function initStickyAtc() {
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }

    if (!stickyBar || !mainBtn || !mobileQuery.matches) {
      if (stickyBar) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    stickyBar.setAttribute('aria-hidden', 'true');

    stickyObserver = new IntersectionObserver(function (entries) {
      const visible = !entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });

    stickyObserver.observe(mainBtn);
  }

  if (stickyBar) {
    stickyBar.querySelector('[data-sticky-atc]')?.addEventListener('click', function () {
      mainBtn?.click();
    });
  }

  initStickyAtc();

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', initStickyAtc);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(initStickyAtc);
  }
})();
